import { render } from "./listForTemporary.vue?vue&type=template&id=787ffb24&ts=true"
import script from "./listForTemporary.vue?vue&type=script&lang=ts&config=true"
export * from "./listForTemporary.vue?vue&type=script&lang=ts&config=true"

import "./listForTemporary.vue?vue&type=style&index=0&id=787ffb24&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__